import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=89d8a32a&scoped=true"
import script from "./CampaignsList.vue?vue&type=script&lang=js"
export * from "./CampaignsList.vue?vue&type=script&lang=js"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=89d8a32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d8a32a",
  null
  
)

export default component.exports